// extracted by mini-css-extract-plugin
export default {"gradeContainer":"style_gradeContainer__RHNZi"};